import React from 'react';
import {
  AppstoreOutlined,
  ApiOutlined,
  BarChartOutlined,
  CalendarOutlined,
  ClearOutlined,
  ClockCircleOutlined,
  CloudUploadOutlined,
  DashboardOutlined,
  FireOutlined,
  GiftOutlined,
  MailOutlined,
  KeyOutlined,
  SafetyCertificateOutlined,
  SettingOutlined,
  ShoppingCartOutlined,
  ToolOutlined,
  UserOutlined,
  WalletOutlined
} from '@ant-design/icons';

export const adminRouteConfig = [
  {
    key: '/',
    routePath: '',
    label: '控制台',
    icon: <DashboardOutlined />,
    section: '概览',
    componentKey: 'Dashboard',
    showInMenu: true
  },
  {
    key: '/servers',
    routePath: 'servers',
    label: '服务器监控',
    icon: <AppstoreOutlined />,
    section: '概览',
    componentKey: 'ServerMonitor',
    showInMenu: true
  },
  {
    key: '/stats',
    routePath: 'stats',
    label: '数据统计',
    icon: <BarChartOutlined />,
    section: '概览',
    componentKey: 'Statistics',
    showInMenu: true
  },
  {
    key: '/users',
    routePath: 'users',
    label: '用户管理',
    icon: <UserOutlined />,
    section: '用户',
    componentKey: 'UserManagement',
    showInMenu: true
  },
  {
    key: '/avatar-reviews',
    routePath: 'avatar-reviews',
    label: '头像审核',
    icon: <SafetyCertificateOutlined />,
    section: '用户',
    componentKey: 'AvatarReviewManagement',
    showInMenu: true
  },
  {
    key: '/agents',
    routePath: 'agents',
    label: '代理管理',
    icon: <SafetyCertificateOutlined />,
    section: '用户',
    componentKey: 'AgentManagement',
    showInMenu: true
  },
  {
    key: '/accounts',
    routePath: 'accounts',
    label: '账号管理',
    icon: <UserOutlined />,
    section: '用户',
    componentKey: 'AccountManagement',
    showInMenu: false
  },
  {
    key: '/mails',
    routePath: 'mails',
    label: '邮件管理',
    icon: <MailOutlined />,
    section: '运营',
    componentKey: 'MailManagement',
    showInMenu: true
  },
  {
    key: '/mall',
    routePath: 'mall',
    label: '商城管理',
    icon: <ShoppingCartOutlined />,
    section: '运营',
    componentKey: 'MallManagement',
    showInMenu: true
  },
  {
    key: '/platform-coin-grants',
    routePath: 'platform-coin-grants',
    label: '平台币补发',
    icon: <WalletOutlined />,
    section: '运营',
    componentKey: 'PlatformCoinGrantManagement',
    showInMenu: true
  },
  {
    key: '/balance-management',
    routePath: 'balance-management',
    label: '余额管理',
    icon: <WalletOutlined />,
    section: '运营',
    componentKey: 'BalanceManagement',
    showInMenu: true
  },
  {
    key: '/payment-providers',
    routePath: 'payment-providers',
    label: '支付接口',
    icon: <ApiOutlined />,
    section: '运营',
    componentKey: 'PaymentProviderManagement',
    showInMenu: true
  },
  {
    key: '/manual-recharge',
    routePath: 'manual-recharge',
    label: '人工代充',
    icon: <ApiOutlined />,
    section: '运营',
    componentKey: 'ManualRechargeManagement',
    showInMenu: true
  },
  {
    key: '/lottery-management',
    routePath: 'lottery-management',
    label: '抽奖管理',
    icon: <FireOutlined />,
    section: '运营',
    componentKey: 'LotteryManagement',
    showInMenu: true
  },
  {
    key: '/activities',
    routePath: 'activities',
    label: '活动管理',
    icon: <CalendarOutlined />,
    section: '运营',
    componentKey: 'ActivityManagement',
    showInMenu: true
  },
  {
    key: '/gifts',
    routePath: 'gifts',
    label: '福利管理',
    icon: <GiftOutlined />,
    section: '运营',
    componentKey: 'GiftManagement',
    showInMenu: true
  },
  {
    key: '/cdks',
    routePath: 'cdks',
    label: 'CDK管理',
    icon: <KeyOutlined />,
    section: '运营',
    componentKey: 'CdkManagement',
    showInMenu: true
  },
  {
    key: '/bubble-rewards',
    routePath: 'bubble-rewards',
    label: '泡点管理',
    icon: <ClockCircleOutlined />,
    section: '运营',
    componentKey: 'BubbleRewardManagement',
    showInMenu: true
  },
  {
    key: '/items',
    routePath: 'items',
    label: '物品管理',
    icon: <ToolOutlined />,
    section: '运营',
    componentKey: 'ItemManagement',
    showInMenu: true
  },
  {
    key: '/client-login',
    routePath: 'client-login',
    label: '客户端登录',
    icon: <UserOutlined />,
    section: '运营',
    componentKey: 'ClientLogin',
    showInMenu: false
  },
  {
    key: '/cheat-scan',
    routePath: 'cheat-scan',
    label: '作弊账号扫描',
    icon: <SafetyCertificateOutlined />,
    section: '风控/安全',
    componentKey: 'CheatAccountScan',
    showInMenu: true
  },
  {
    key: '/item-clear',
    routePath: 'item-clear',
    label: '道具清空',
    icon: <ClearOutlined />,
    section: '风控/安全',
    componentKey: 'ItemClearManagement',
    showInMenu: true
  },
  {
    key: '/configs',
    routePath: 'configs',
    label: '配置管理',
    icon: <SettingOutlined />,
    section: '系统',
    componentKey: 'ConfigManagement',
    showInMenu: true
  },
  {
    key: '/client-updates',
    routePath: 'client-updates',
    label: '版本更新',
    icon: <CloudUploadOutlined />,
    section: '系统',
    componentKey: 'ClientUpdateManagement',
    showInMenu: true
  }
];

const MENU_SECTION_ORDER = ['概览', '用户', '运营', '风控/安全', '系统'];

export function buildAdminMenuItems() {
  return MENU_SECTION_ORDER.map((section) => {
    const children = adminRouteConfig
      .filter((route) => route.showInMenu && route.section === section)
      .map((route) => ({
        key: route.key,
        icon: route.icon,
        label: route.label
      }));

    return {
      type: 'group',
      key: `group-${section}`,
      label: section,
      children
    };
  }).filter((group) => group.children.length > 0);
}

export function getAdminRouteMeta(pathname = '/') {
  const matchedRoute = adminRouteConfig.find((route) => route.key === pathname);

  if (matchedRoute) {
    return matchedRoute;
  }

  return adminRouteConfig.find((route) => route.key === '/') || null;
}
